module.exports = __webpack_public_path__ + "img/10_11_12_13_replay.72df87fc.png";